import { Injectable } from '@angular/core';
import { BrandingService } from './branding.service';


@Injectable({
  providedIn: 'root'
})
export class DataLayerResidentialService {

  dataLayerResidential = false;

  constructor(private brandingService: BrandingService) {
    this.brandingService.dataLayerResidential$.subscribe(res => this.dataLayerResidential = res);
  }

  formAppendedData() {
    if (this.dataLayerResidential) {
      (window as any).dataLayer.push({
        eventCategory: '',
        eventAction: '',
        eventLabel: '',
        eventValue: 1,
        eventNonInteraction: 'true',
        appendeddata: '<BOOLEN>',
        event: 'eventPush'
      });
    }
  }

  formImpressionOne() {
    if (this.dataLayerResidential) {
      (window as any).dataLayer.push({
        eventCategory: 'Get Covered Insurance',
        eventAction: 'Impression - Step1',
        eventLabel: '',
        eventValue: 1,
        eventNonInteraction: 'true',
        event: 'eventPush'});
    }
  }

  formSubmitOne() {
    if (this.dataLayerResidential) {
      (window as any).dataLayer.push({
        eventCategory: 'Get Covered Insurance',
        eventAction: 'Submit - Step1',
        eventLabel: '',
        eventValue: 1,
        eventNonInteraction: true,
        event: 'eventPush'
      });
    }
  }

  formImpressionTwo() {
    if (this.dataLayerResidential) {
      (window as any).dataLayer.push({
        eventCategory: 'Get Covered Insurance',
        eventAction: 'Impression - Step2',
        eventLabel: '',
        eventValue: 1,
        eventNonInteraction: true,
        event: 'eventPush'
      });
    }
  }

  formSubmitTwo() {
    this.formImpressionTwo();
    if (this.dataLayerResidential) {
      (window as any).dataLayer.push({
        eventCategory: 'Get Covered Insurance',
        eventAction: 'Submit - Step2',
        eventLabel: '',
        eventValue: 1,
        eventNonInteraction: true,
        event: 'eventPush'
      });
    }
  }
}
